import React from 'react';
import PdfCompany from '../../utils/pdf/companySchedule';
import PdfAllCompany from '../../utils/pdf/allCompanySchedule';
import PdfAllInvestors from '../../utils/pdf/allInvestorsSchedule';
import PdfInvestor from '../../utils/pdf/investorSchedule';
import GetEvent from '../../services/getEvent';
import GetCompany from '../../services/getCompany';
import GetCompanies from '../../services/getCompanies';
import GetInvestors from '../../services/getInvestors';
import GetMeetings from '../../services/getMeetings';
import Cookies from 'universal-cookie';
import PdfDocument from '../../utils/pdf/companySchedule';
import getInvestor from '../../services/getInvestor';
import SaveFile from '../../services/saveFile';
import CreateDirectory from '../../services/createDirectory';
import GetCompaniesExcel from '../../services/getCompaniesExcel';
import Constants from "../../utils/consts";
import AllMeetingsExcel from "../../utils/excel/allMeetings";
import moment from 'moment';

import {
  Save as Save,
} from "@material-ui/icons";

export default class PdfPage extends React.Component {

  async componentDidMount(){
    const cookies = new Cookies();
    var token = cookies.get('token', { path: '/' });
    var uname = cookies.get('username', { path: '/' });
    const currentEventId = cookies.get('currentEventId', { path: '/' });

    this.event = await GetEvent(uname, token, currentEventId);

    this.scheduleType = cookies.get('scheduleType');
    this.scheduleSubject = cookies.get('scheduleSubject');

    this.companies = await GetCompanies(uname, token, currentEventId);
    this.investors = await GetInvestors(uname, token, currentEventId);
    this.company = await GetCompany(uname, token, currentEventId, this.scheduleSubject);
    this.investor = await getInvestor(uname, token, currentEventId, this.scheduleSubject);
    this.meetings = await GetMeetings(uname, token, currentEventId);

    var startDate = moment(this.event.startDate, "DD/MM/yyyy");
    var endDate = moment(this.event.endDate, "DD/MM/yyyy");


    this.eventDays = [];
    var tempDate = startDate;
    while (tempDate <= endDate){
      this.eventDays.push(moment(tempDate));
      tempDate = tempDate.add(1, 'd');
    }

    var filterMeetings = this.meetings.filter((elem) => elem.company_id == this.company.id);
    var infoSchedules = this.event.brokersInfoSchedulesCompaniesEnabled;

    var jsonTabs = [];

    this.eventDays.map(v => {
        
      var jsonData = [];

      let date = moment(v).format('DD/MM/yyyy');
      let dateComplete = moment(v).format('dddd, DD MMMM yyyy');
      
      let filterMeetingsDate = filterMeetings.filter((elem) => elem.date == date);
      let sortMeetings = filterMeetingsDate.sort((a, b) => {
          var time1 = moment(a.date + " " + a.hour+":"+a.minutes, "DD/MM/yyyy HH:mm");
          var time2 = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");

          return time1 - time2;
      });

      if (sortMeetings.length <= 0) return null;

      sortMeetings.map(m => {
                  let meetingTime = moment(parseInt(m.hour)+":"+parseInt(m.minutes), "hh:mm");
                  let meetingEndTime = moment(meetingTime).add(m.slots * 5, 'minutes');

                  let strTime = moment(meetingTime).format("HH:mm");
                  let strEndTime = moment(meetingEndTime).format("HH:mm");

                  var companiesList = [];
                  m.investors.map(inv => {
                      if (inv.isAnalyst == 0 && companiesList.indexOf(inv.company) == -1)
                          companiesList.push(inv.company);
                  });

                  var meetingDesc = '';
                  if (companiesList.length == 0) meetingDesc += "Analysts Meeting with: \n";
                  else if (companiesList.length == 1) meetingDesc += "1 to 1 Meeting with: \n";
                  else if (companiesList.length < 5) meetingDesc += "1 to Few Meeting with: \n";
                  else meetingDesc += "Group Meeting with: \n";

                  m.investors.map((investor, index) => {
                    var str = '<b>' + investor.company + '</b>';
                      meetingDesc += str;
                      if (investor.company != '') 
                          meetingDesc += ' - ' + investor.name;
                      if (infoSchedules == 1) 
                          meetingDesc += ' (hosted by ' + investor.broker+ ')';

                  });

                  jsonData.push([strTime + ' - ' + strEndTime, meetingDesc]);
              }) 

              jsonTabs.push({
                name: dateComplete,
                data: jsonData
              });

            });

    var json = {
      tabs : jsonTabs
    };

    await GetCompaniesExcel(uname, token, JSON.stringify(json), this.company.name);
    window.location.href= Constants.mainUrl+'apis/files/'+this.company.name+'.xlsx';

    this.setState({});
  }

  async onRender(data){
      const cookies = new Cookies();
      const username = cookies.get('username', { path: '/' });
      const token = cookies.get('token', { path: '/' });
      this.dirName = await CreateDirectory(username, token) + '/';

      await SaveFile(username, token, this.dirName + this.fileName, data);
      
    }

  render(){

    this.fileName = '';
    this.dirName = '';

    if (this.scheduleType == undefined) return <div />;
    var element = <PdfDocument />;
    if (this.scheduleType == 'company'){
      element = <PdfCompany key={Math.random()} event={this.event} company={this.company} meetings={this.meetings} onRender={(data) => this.onRender(data)} />;
      this.fileName = this.company.name + '.pdf';
    } else if (this.scheduleType == 'investor'){
      element = <PdfInvestor key={Math.random()} event={this.event} investor={this.investor} meetings={this.meetings} onRender={(data) => this.onRender(data)} />;
      this.fileName = this.investor.company + ' - ' + this.investor.name + '.pdf';
    } else if (this.scheduleType == 'allCompanies'){
      element = <PdfAllCompany key={Math.random()} event={this.event} companies={this.companies} meetings={this.meetings} onRender={(data) => this.onRender(data)} />;
      this.fileName = 'companies.pdf';
    } else if (this.scheduleType == 'allInvestors'){
      element = <PdfAllInvestors key={Math.random()} event={this.event} investors={this.investors} meetings={this.meetings} onRender={(data) => this.onRender(data)} />;
      this.fileName = 'investors.pdf';
    }


    return (
      <div>
        <AllMeetingsExcel></AllMeetingsExcel>
      </div>
    );
  }

}

